import React, { useEffect, useMemo, useState } from "react";
import {
  Layout,
  Card,
  Button,
  Input,
  Radio,
  Popconfirm,
  Form,
  InputNumber,
  message,
  Select,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import CustomThemeDrawer from "../../../../Elements/CustomThemeDrawer";
import { APIConstants } from "../../../../../Common/APIConstants";

const GroupConfiguration = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [refetch2, setRefetch2] = useState(false);
  const [refetch3, setRefetch3] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    form1.resetFields()
    setOpen(false);
    setGroupId(null)
    setSubGroup([])
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    //  form2.resetFields();
    setSubGroup([]);
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    // form3.resetFields()
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { isdarkMode } = mode;

  const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [updateExternalEnergySources, setUpdateExternalEnergySources] =
    useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);

  const [newExternalSource, setNewExternalSource] = useState("");
  const [newProductionData, setNewProductionData] = useState("");
  const [newResourceDetail, setNewResourceDetail] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedSubGroupValue, setSelectedSubGroupValue] = useState("");
  const [groupData, setGroupData] = useState([]);
  const [groupDataG, setGroupDataG] = useState([]);
  const [subGroupData, setSubGroupData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [groupname, setGroupname] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [groupID, setGroupId] = useState(null);
  const [consumptionDetail, setConsumptionDetails] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]
  );
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
    const [moduleG,setModuleG]=useState(null)
  useEffect(() => {
    if (open) {
      //  Group Name
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
      }).then((res) => { 
        // if (res) {
        //   const filteredGroupnames = res.filter(
        //     (group) => group.groupID === 6 || group.groupID === 7
        //   );
        //   setGroupname(filteredGroupnames);
        // }
        if (res) {
          setGroupname(res);
        }
      });

      //  Converter Data
      makeRequest({
        type: APIConstants.GET,
        url: moduleG == 3
                  ? `${APIConstants.TEMP_CONVERTERS}?ModuleType=${moduleG}`
                  : `${APIConstants.FLOW_CONVERTERS}?ModuleType=${moduleG}`,
      }).then((res) => {
        setgetFlowConverterResData(res);
      });

      //  Consumption Details
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_CONSUMPTION_DETAILS}`,
      }).then((res) => {
        console.log(res)
        setConsumptionDetails(res); 
      });
    }
  }, [open,moduleG]);


  const [subGroupDataG, setSubGroupDataG] = useState([]);
  const [groupName,setGroupName]=useState()
  // Sub group
  useEffect(() => {
    //console.log(groupID)
    if (groupID != null) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_SUB_GROUPDETAILS}?GroupId=${groupID}`,
      })
        .then((res) => {
          setSubGroup(res);
        })
        .catch((error) => {
          //console.error("Error fetching sub groups:", error);
          setSubGroup([]);
        });
    }
  }, [groupID]);
  useEffect(() => {
    form1.setFieldsValue({
      subgroup: undefined,
      convertername: undefined,
      consumption: undefined,
      metertype: undefined,
      meters: undefined,
    });
  }, [groupID]);

  // Converter
  useEffect(() => {
    if (converterGroupId&&moduleG) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.TEMP_METERS}?SiteID=${converterGroupId}&MeterType=${moduleG}`,
        // url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        console.log(res)
        setnsGetFlowConverterResData(res);
      });
    }
  }, [converterGroupId]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const getGroup = () => {
    //console.log(formValues);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.GET_FLOW_GROUP}?ModuleType=${module}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setGroupData(res);
      }
    });
  };
  const getGroupforSubGroup = () => {
    //console.log(formValues);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.GET_FLOW_GROUP}?ModuleType=${moduleG}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setGroupDataG(res);
      }
    });
  };
  const getSubGroup = () => {
    //console.log(selectedValue);
    const url = `${APIConstants.GET_FLOW_SUB_GROUP}?FlowGroupID=${selectedValue}`;
    // const url = `${APIConstants.DEVICE_DETAILS}`;
    //console.log(url);
    if (selectedValue) {
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => {
        //console.log(res);
        if (res) {
          setSubGroupData(res);
        }
      });
    }
  };
  const getSubGroupForForm = () => {
    console.log(groupName);
    const url = `${APIConstants.GET_FLOW_SUB_GROUP}?FlowGroupID=${groupName}`;
    // const url = `${APIConstants.DEVICE_DETAILS}`;
    //console.log(url);
    if (groupName) {
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => {
        console.log(res);
        if (res) {
          setSubGroupDataG(res);
        }
      });
    }
  };
  const getDevices = (values) => {
    console.log("Form values:", values);

    if (values) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_SUB_GROUP_METER}?FlowSubGroupID=${values.flowSubGroupID}&ModuleType=${values.moduleType}`,
      })
        .then((res) => {
          //console.log("Meter Details:", res);
          if (res && res.length ) {
            //  setShowGrid(true);
            setDeviceData(res);
          }else{
            setDeviceData([]);

          }
        })
        .catch((err) => {
          //console.error("Error fetching meter details", err);
        });
    } else {
      //console.error("Something went wrong");
    }
  };
  useEffect(() => {
    //console.log(selectedSubGroupValue);
    if (selectedSubGroupValue) {
      getDevices(selectedSubGroupValue);
    }

    if (selectedSubGroupValue == null) {
      setDeviceData([]);
    }
  }, [selectedSubGroupValue, refetch]);

  useEffect(() => {
    getSubGroup();
  }, [selectedValue, refetch3]);
  useEffect(() => {
    getSubGroupForForm();
  }, [groupName]);
  useEffect(() => {
    //console.log('selectedValue')
    //console.log(selectedValue)
    if (selectedValue == null) {
      //console.log('novalue')
      setSubGroupData([]);
    }
  }, [selectedValue]);
   const [moduleList, setModuleList] = useState([
      { id: 1, name: "Electrical" },
      { id: 2, name: "Temperature" },
      { id: 3, name: "Air" },
      { id: 4, name: "Water" },
    ]);
    const [module, setModule] = useState();
   useEffect(() => {
     makeRequest({
       type: APIConstants.GET,
       // GetFlowSteamGropeMeterDetails?GroupID=81
       url: `${APIConstants.FLOW_MODULES}`,
     }).then((res) => {
       console.log(res);
       if (res && res.length > 0) {
        const data = res?.filter((i)=>i.moduleName!=='Temperature')
        console.log(data)
         setModuleList(data);
         setModule(res[0]?.moduleId)
       }
     });
   }, [])
  useEffect(() => {
    getGroup();
  }, [refetch2,module]);
  useEffect(() => {
    getGroupforSubGroup();
  }, [moduleG]);

  const deleteDevices=(values)=>{
    console.log(values)
    const body={
      meterAutoID:values.meterAutoID
    }
    console.log(body)
        const url = `${APIConstants.FLOW_GROUP_DEVICE_DELETE}?MeterAutoID=${body.meterAutoID}`;


    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {

      setRefetch2(!refetch2);
      setRefetch(!refetch);
      setRefetch3(!refetch3);
      handleNotification(res.message, "success");
    });
  }


  const deviceCols = [
    { headerName: "S.No", field: "meterAutoID", width: 80 },
    // { headerName: "Group ID", field: "groupID", flex: 1 },
    { headerName: "SubGroup ID ", field: "flowSubGroupID", flex: 1, minWidth: 120 },
    {
      headerName: "SubGroup Name ",
      field: "flowSubGroupName",
      flex: 1,
      minWidth: 120,
    },
    { headerName: "Meter ID", field: "meterID", flex: 1, minWidth: 120 },
    { headerName: "MeterName", field: "meterName", flex: 1, minWidth: 120 },
    { headerName: "Site Name", field: "siteName", flex: 1, minWidth: 120 },
    {
      headerName: "Function",
      field: "meterType",
      flex: 1,
      minWidth: 120,
      // valueGetter: (params) => {
      //   const val = params.data?.meterType;
      //   return val === true || val === "true" ? "Plus" : "Minus";
      // },
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Actions",
      width: 100,
      cellRenderer: (params) => (
        <div className="space-x-2">
          <Popconfirm
            title="Are you sure to delete this device?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => deleteDevices(params.data)}
            trigger="click"
          >
            <span
              className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
                      transition-transform duration-200 hover:border-[1px] border-red-400"
            >
              <DeleteOutlined />
            </span>
          </Popconfirm>
        </div>
      ),
    }
  ];

  const groupCols = [
    {
      headerName: "",
      field: "select",
      width: 30,
      headerCheckboxSelection: false, // optional
      cellRenderer: (params) => {
        return (
          <input
            type="checkbox" // Change to "checkbox" if you prefer
            name="rowSelect"
            defaultChecked={params.data.flowGroupID === selectedValue}
            onChange={(e) => {
              if (e.target.checked) {
                //console.log("Selected Row:", params.data);
                setSelectedValue(params.data.flowGroupID);
              } else {
                setSelectedValue(null);
                //console.log("Unchecked Row:", params.data);
              }
            }}
          />
        );
      },
    },
    { headerName: "Group ID", field: "flowGroupID", minWidth: 100, flex: 1 },
    { headerName: "Group Names", field: "flowGroupName", minWidth: 100, flex: 1 },
    {
      headerName: "Actions",
      width: 100,
      // flex:1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteGroup(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  //console.log(selectedSubGroupValue)
  //console.log(subGroupData)

  const subGroupCols = [
    {
      headerName: "",
      field: "select",
      width: 30,
      headerCheckboxSelection: false, // optional
      cellRenderer: (params) => {
        return (
          <input
            type="checkbox" // Change to "checkbox" if you prefer
            name="rowSelect"
            defaultChecked={params.data.flowSubGroupID === selectedSubGroupValue}
            onChange={(e) => {
              if (e.target.checked) {
                //console.log("Selected Row:", params.data);
                setSelectedSubGroupValue(params.data);
              } else {
                setSelectedSubGroupValue(null);
                //console.log("Unchecked Row:", params.data);
              }
            }}
          />
        );
      },
    },
    { headerName: "Sub Group ID", field: "flowSubGroupID", minWidth: 100, flex: 1 },
    { headerName: "Sub Group", field: "flowSubGroupName", minWidth: 100, flex: 1 },
    {
      headerName: "Actions",
      width: 100,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteSubGroup(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const handleAddExternalEnergy = () => {
    //console.log(newExternalSource);
    const newData = {
      sourceID: externalEnergySources.length + 1,
      sourceName: newExternalSource,
    };
    setExternalEnergySources([newData, ...externalEnergySources]);
    setNewExternalSource("");
    onClose();
  };

  const onFinish2 = (values) => {
    //   setFormValues(values);
    form2.resetFields();
    //console.log(values); // Log the form values
    //   handleOk();
    insertGroup(values);
  };

  const insertGroup = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.INSERT_FLOW_GROUP}?FlowGroupName=${formValues.department}&ModuleType=${formValues.module}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
    //   body: formValues,
    }).then((res) => {
      setRefetch2(!refetch2);
      onClose2();
      handleNotification(res?.message, "success");
      //console.log(res?.message);
    });
  };
  const deleteGroup = (formValues) => {
    console.log(formValues);

    const body = {
      flowGroupID: formValues.flowGroupID,
    };

    const url = `${APIConstants.DELETE_FLOW_GROUP}?FlowGroupID=${formValues.flowGroupID}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      onClose2();
      setRefetch2(!refetch2);
      setRefetch(!refetch);
      setRefetch3(!refetch3);
      setDeviceData([]);
      handleNotification(res.message, "success");
    });
  };

  const onFinish3 = (values) => {
    // setFormValues(values);
    console.log(values);
    const formData = (values) => {
      return {
        FlowGroupID: values.groupID?.key || null,
        ModuleType: values?.module|| null,
        FlowSubGroupName: values.subGroupName || null,
      };
    };
    const formValues = formData(values);
    //console.log(formValues);
    onClose3();
    insertSubGroup(formValues);
    form3.resetFields(); // Reset form fields after submission
  };

  const insertSubGroup = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.INSERT_FLOW_SUB_GROUP}?FlowSubGroupName=${formValues.FlowSubGroupName}&FlowGroupID=${formValues.FlowGroupID}&ModuleType=${formValues.ModuleType}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      // body: formValues,
    })
      .then((res) => {
        //console.log(res);
        // setRefetch3(!refetch3)

        handleNotification("Sub Group added successfully!", "success");
      })
      .catch((err) => {
        handleNotification("Something went wrong!", "error");
      });
  };
  const deleteSubGroup = (formValues) => {
    console.log(formValues);
    // setSelectedValue(formValues.groupID)

    const body = {
      subGroupID: formValues.subGroupID,
    };

    const url = `${APIConstants.DELETE_FLOW_SUB_GROUP}?FlowSubGroupID=${formValues.flowSubGroupID}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      // setRefetch2(!refetch2);
      setRefetch(!refetch);
      setRefetch3(!refetch3);
      handleNotification(res.message, "success");
    });
  };
  const onFinish1 = (values) => {
    console.log(values)
    console.log(subGroupDataG)
    console.log(groupData)
    const selectedGroup = groupData.find(
      (group) => group.flowGroupID === values.groupName
    );
    // console.log(selectedGroup)
    const selectedSubGroup = subGroupDataG.find(
      (subgroup) => subgroup.flowSubGroupID === values.subgroup
    );
    // console.log(getFlowConverterResData)

    const selectedConverter = getFlowConverterResData.find(
      (converter) => converter.sitE_ID === values.convertername
    );
    console.log(selectedConverter)
    const selectedConsumption = consumptionDetail.find(
      (consumption) => consumption.parametername === values.consumption
    ); 

    console.log(selectedMeterIds)
 
    const meterIdsAndNames = selectedMeterIds
      .map(({ meterId, meterName }) => `${meterId}$${meterName}`)
      .join(",");
    const meterTypeValue = values.metertype === "type1";
    console.log(meterIdsAndNames)

    const transformedData = {
      siteID: selectedConverter.sitE_ID,
      siteName: selectedConverter.sitename,
      FlowGroupName:selectedGroup.flowGroupName,
      FlowGroupID:selectedGroup.flowGroupID,
      FlowSubGroupName:selectedSubGroup.flowSubGroupName,
      FlowSubGroupID:selectedSubGroup.flowSubGroupID,
      MeterIdsandMeterName: meterIdsAndNames,
      MeterType: values?.metertype,
      ModuleType:values.module, 
      // subGroupID: selectedSubGroup.subGroupID,
      // consumption: selectedConsumption.parameterid,
    };

    // http://49.206.200.53:92/InsertFlowGroupMetersDetails?MeterIdsandMeterName=1&FlowGroupID=1&FlowGroupName=1&FlowSubGroupID=1&FlowSubGroupName=1&SiteID=1&SiteName=1&MeterType=1&ModuleType=1
    console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.INSERT_FLOW_SUB_GROUP_METER}?MeterIdsandMeterName=${transformedData.MeterIdsandMeterName}&FlowGroupID=${transformedData.FlowGroupID}&FlowGroupName=${transformedData.FlowGroupName}&FlowSubGroupID=${transformedData.FlowSubGroupID}&FlowSubGroupName=${transformedData.FlowSubGroupName}&SiteID=${transformedData.siteID}&SiteName=${transformedData.siteName}&MeterType=${transformedData.MeterType}&ModuleType=${transformedData.ModuleType}`,
      body: transformedData,
    })
      .then((res) => {
        console.log("API Response:", res);
        //console.log("Transformed Data:", transformedData);
        message.success("Group Config saved successfully!");

        onClose();
        form1.resetFields();
      })
      .catch((error) => {
        //console.error("Error saving Group Config:", error);
      });
  };

  const handleMeterChange = (selectedKeys) => {
    console.log(nsGetFlowConverterResData)
    console.log(selectedKeys)
    const selectedMeters = selectedKeys
      .map((selectedKey) => {
        const meter = nsGetFlowConverterResData.find(
          (meter) => meter.meteR_METERID === selectedKey
        );
        return meter
          ? { meterId: meter.meteR_METERID, meterName: meter.metername }
          : null;
      })
      .filter(Boolean);

    setSelectedMeterIds(selectedMeters);
  };
  useEffect(() => {
    setDeviceData([]);
    setSelectedSubGroupValue("");
  }, [selectedValue]);
  // useEffect(() => {
  //   setSelectedMeterIds([]);
  //   console.log(converterGroupId)
  //   console.log(selectedMeterIds)
  // }, [converterGroupId]);
  console.log(selectedMeterIds)
  console.log(groupData)
  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Groups
        </h2>
   <div className="">
          <Radio.Group 
          optionType="button"
      buttonStyle="solid"
      block
        value={module}
        onChange={(e) =>{
          setDeviceData([])
          setSubGroupData([])
          setModule(e.target.value)}

        } 
        style={{ marginBottom: 16 }}
      >
        {moduleList.map((module) => (
          <Radio.Button  key={module.moduleId} value={module.moduleId}>
            {module.moduleName}
          </Radio.Button>
        ))}
      </Radio.Group>

      </div>
        <div className="flex gap-4 h-[90vh]">
          {/* Group */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Group
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer2()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={groupData}
                columnDefs={groupCols}
                domLayout="normal"
              />
            </div>
          </Card>

          {/* Sub Group */}
          {/* {subGroupData.length > 0 && ( */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Sub Group
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer3()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={subGroupData}
                columnDefs={subGroupCols}
                domLayout="normal"
              />
            </div>
          </Card>
          {/* )} */}
          {/* External Energy Sources */}
          {/* {deviceData.length > 0 && ( */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Grouping Devices
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer()}>
                Add +
              </Button>
            }
            className={`w-2/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={deviceData}
                columnDefs={deviceCols}
                domLayout="normal"
                rowHeight={50}
              />
            </div>
          </Card>
          {/* )} */}
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form1}
            name="add-Group-Config"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
            }}
            labelAlign="left"
            onFinish={onFinish1}
            className="p-3"
          >

                 <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Module
                </span>
              }
              name="module"
              rules={[{ required: true, message: "Please select module!" }]}
            >
             <Select
                placeholder="Select module"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
                onChange={(value) => {
                  console.log(value)
                  form1.setFieldsValue({ groupName: [],subgroup:[] ,convertername:[],meters:[]});
                  setModuleG(value);
                }}
              > 
                {moduleList.map((group) => (
                  <Select.Option key={group.moduleId} value={group.moduleId}>
                    {group.moduleName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {/* Group Name */}
            <Form.Item
              // label="Group Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Group Name
                </span>
              }
              name="groupName"
              rules={[
                {
                  required: true,
                  message: "Please select a group!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                // labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
                onChange={(value) => {
                  // form1.setFieldsValue({ meters: [] });
                  setGroupName(value)
                  console.log(value)
                }}
              >
                {groupDataG.map((i) => (
                  <Option key={i.flowGroupID} value={i.flowGroupID}>
                    {i.flowGroupName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Sub Group */}
            <Form.Item
              // label="Sub Group"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Sub Group
                </span>
              }
              name="subgroup"
              rules={[{ required: true, message: "Please select Sub Group!" }]}
            >
              <Select
                placeholder="Select Sub Group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {subGroupDataG &&
                  subGroupDataG.map((group) => (
                    <Select.Option
                      key={group.flowSubGroupID}
                      value={group.flowSubGroupID}
                    >
                      {group.flowSubGroupName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Converter */}
            <Form.Item
              // label="Converter Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter Name
                </span>
              }
              name="convertername"
              rules={[
                { required: true, message: "Please select Converter Name!" },
              ]}
            >
              <Select
                placeholder="Select Converter Name"
                onChange={(value) => {
                  form1.setFieldsValue({ meters: [] });
                  setConverterGroupId(value)
                  console.log(value)
                }}
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {getFlowConverterResData &&
                  getFlowConverterResData.map((val) => (
                    <Select.Option key={val.sitE_ID} value={val.sitE_ID}> 
                      {val.sitename}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Consumption */}
            {/* <Form.Item
              // label="Consumption"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Consumption
                </span>
              }
              name="consumption"
              rules={[
                { required: true, message: "Please select Consumption!" },
              ]}
            >
              <Select
                placeholder="Select Consumption"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {consumptionDetail &&
                  consumptionDetail.map((param) => (
                    <Select.Option
                      key={param.parameterid}
                      value={param.parametername}
                    >
                      {param.parametername}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item> */}

            {/* Meter Type */}
            <Form.Item
              // label="Function"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Function
                </span>
              }
              name="metertype"
              rules={[
                { required: true, message: "Please select Device Type!" },
              ]}
            >
              <Select
                placeholder="Select Device Type"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                <Select.Option value="Plus">Plus</Select.Option>
                <Select.Option value="Minus">Minus</Select.Option>
              </Select>
            </Form.Item>

            {/* TreeSelect for Meters */}
            <Form.Item
              // label="Device"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Devices
                </span>
              }
              name="meters"
              rules={[{ required: true, message: "Please select devices!" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select Device"
                value={selectedMeterIds}
                onChange={handleMeterChange}
                optionLabelProp="label"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {nsGetFlowConverterResData.map((meter) => (
                  <Select.Option
                    key={meter.meteR_METERID}
                    value={meter.meteR_METERID}
                    label={meter.metername}
                  >
                    {meter.metername}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Footer Buttons */}
            {/* <Form.Item
                   wrapperCol={{
                     offset: 16,
                     span: 16,
                   }}
                 >
                   <Button key="back" className="mr-3" onClick={handleCancel}>
                     Cancel
                   </Button>
         
                   <Button htmlType="submit" type="primary" loading={loading}>
                     Save
                   </Button>
                 </Form.Item> */}
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form1.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form2}
            name="Group-add-form"
            className="font-bold"
            layout="horizontal"
            style={{ maxWidth: 600 }}
            labelCol={{ span: 8, offset: 0 }}
            labelAlign="left"
            onFinish={onFinish2}
          >
            <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Module 
                </span>
              }
              name="module"
              rules={[{ required: true, message: "Please select module!" }]}
            >
             <Select
                placeholder="Select module"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
                onChange={(value) => {
                  const selectedGroup = groupname.find(
                    (group) => group.moduleId === value
                  );
                  if (selectedGroup) {
                    setModule(selectedGroup.moduleId);
                  }
                }}
              >
                {moduleList.map((group) => (
                  <Select.Option key={group.moduleId} value={group.moduleId}>
                    {group.moduleName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              // label="Group"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Group Name
                </span>
              }
              name="department"
              rules={[{ required: true, message: "Please input department!" }]}
            >
              <Input
                placeholder="Enter a group name"
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
              />
            </Form.Item>


          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2} className="">
              Cancel
            </Button>
            <Button
              // htmlType="submit"
              type="primary"
              //   disabled={!newProductionData.trim()}
              onClick={() => form2.submit()}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer3}
        open={open3}
        onClose={onClose3}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form3}
            name="Group-add-form"
            className="font-bold"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
            onFinish={onFinish3}
          >
             <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Module 
                </span>
              }
              name="module"
              rules={[{ required: true, message: "Please select module!" }]}
            >
             <Select
                placeholder="Select module"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
                onChange={(value) => {
                  console.log(value)
                  form3.setFieldsValue({ groupID: [],subGroupName:[] });
                  setModuleG(value);
                }}
              >
                {moduleList.map((group) => (
                  <Select.Option key={group.moduleId} value={group.moduleId}>
                    {group.moduleName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              // label="Group Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Group Name
                </span>
              }
              name="groupID"
              rules={[
                {
                  required: true,
                  message: "Please select a group!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {groupDataG.map((i) => (
                  <Option key={i.flowGroupID} value={i.flowGroupID}>
                    {i.flowGroupName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              // label="Sub-Group Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Sub-Group Name
                </span>
              }
              name="subGroupName"
              rules={[
                {
                  required: true,
                  message: "Please input Group ID!",
                },
              ]}
            >
              <Input
                placeholder="Enter a sub group name"
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose3} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form3.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default GroupConfiguration;
